// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voucherPayment_voucher_payment_wrapper__Nduz5 .voucherPayment_search_wrapper__DxCxH {
  display: flex;
  flex-direction: row;
  gap: 20px;
  max-width: 300px;
}
.voucherPayment_voucher_payment_wrapper__Nduz5 .voucherPayment_search_wrapper__DxCxH button {
  padding: 5px 10px;
  height: 40px;
  border: none;
  background-color: var(--green-light);
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
}
.voucherPayment_voucher_payment_wrapper__Nduz5 .voucherPayment_search_wrapper__DxCxH button:hover {
  background-color: var(--primary-color);
  color: white;
}
.voucherPayment_voucher_payment_wrapper__Nduz5 .voucherPayment_search_wrapper__DxCxH button:disabled {
  background-color: #f0f0f0;
  color: #b3b3b3;
  cursor: not-allowed;
}
.voucherPayment_voucher_payment_wrapper__Nduz5 .voucherPayment_search_wrapper__DxCxH button img {
  width: 24px;
  height: 24px;
}
.voucherPayment_voucher_payment_wrapper__Nduz5 .voucherPayment_search_wrapper__DxCxH input {
  width: 100%;
  padding: 10px;
  height: 40px;
  border: none;
  font-size: 16px;
  font-weight: 400;
}
.voucherPayment_voucher_payment_wrapper__Nduz5 .voucherPayment_voucher_payment_button__8XP0l {
  margin: 0 auto;
}
.voucherPayment_voucher_payment_wrapper__Nduz5 .voucherPayment_voucher_payment_button__8XP0l:disabled {
  background-color: #f0f0f0;
  color: #b3b3b3;
  border-color: #b3b3b3;
  cursor: not-allowed;
}

.voucherPayment_payment_button__BHzZ\\+ {
  max-width: 300px;
  display: flex;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  padding: 15px 20px;
  border: none;
  background-color: var(--green-light);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
}
.voucherPayment_payment_button__BHzZ\\+ img {
  width: 30px;
}

.voucherPayment_payment_button__BHzZ\\+:hover {
  background-color: var(--primary-color);
  color: white;
  transition: all 0.3s;
}

.voucherPayment_disabled__egMaA {
  background-color: #f0f0f0;
  color: #b3b3b3;
  cursor: not-allowed;
}
.voucherPayment_disabled__egMaA:hover {
  background-color: #f0f0f0;
  color: #b3b3b3;
}

.voucherPayment_voucher_list__kjEQk ul {
  display: flex;
  flex-direction: column;
  gap: 14px;
  list-style-type: none;
  padding: 0;
}
.voucherPayment_voucher_list__kjEQk ul li {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.voucherPayment_voucher_list__kjEQk ul li button {
  border-radius: 5px;
  border: 1px solid var(--green-light);
  background-color: var(--green-light);
  padding: 2px 4px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
}
.voucherPayment_voucher_list__kjEQk ul li button:hover {
  background-color: var(--primary-color);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Payment/VoucherPayment/voucherPayment.module.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAAJ;AAEI;EACE,iBAAA;EACA,YAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AAAN;AAEM;EACE,sCAAA;EACA,YAAA;AAAR;AAGM;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AADR;AAIM;EACE,WAAA;EACA,YAAA;AAFR;AAMI;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAJN;AAQE;EACE,cAAA;AANJ;AAQI;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;AANN;;AAWA;EACE,gBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AARF;AASE;EACE,WAAA;AAPJ;;AAWA;EACE,sCAAA;EACA,YAAA;EAEA,oBAAA;AATF;;AAYA;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AATF;AAWE;EACE,yBAAA;EACA,cAAA;AATJ;;AAcE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;EACA,UAAA;AAXJ;AAaI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAXN;AAaM;EACE,kBAAA;EACA,oCAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;AAXR;AAaQ;EACE,sCAAA;EACA,YAAA;AAXV","sourcesContent":[".voucher_payment_wrapper {\n  .search_wrapper {\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    max-width: 300px;\n\n    button {\n      padding: 5px 10px;\n      height: 40px;\n      border: none;\n      background-color: var(--green-light);\n      border-radius: 5px;\n      cursor: pointer;\n      transition: all 0.3s;\n\n      &:hover {\n        background-color: var(--primary-color);\n        color: white;\n      }\n\n      &:disabled {\n        background-color: #f0f0f0;\n        color: #b3b3b3;\n        cursor: not-allowed;\n      }\n\n      img {\n        width: 24px;\n        height: 24px;\n      }\n    }\n\n    input {\n      width: 100%;\n      padding: 10px;\n      height: 40px;\n      border: none;\n      font-size: 16px;\n      font-weight: 400;\n    }\n  }\n\n  .voucher_payment_button {\n    margin: 0 auto;\n\n    &:disabled {\n      background-color: #f0f0f0;\n      color: #b3b3b3;\n      border-color: #b3b3b3;\n      cursor: not-allowed;\n    }\n  }\n}\n\n.payment_button {\n  max-width: 300px;\n  display: flex;\n  gap: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 5px;\n  padding: 15px 20px;\n  border: none;\n  background-color: var(--green-light);\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.3s;\n  img {\n    width: 30px;\n  }\n}\n\n.payment_button:hover {\n  background-color: var(--primary-color);\n  color: white;\n\n  transition: all 0.3s;\n}\n\n.disabled {\n  background-color: #f0f0f0;\n  color: #b3b3b3;\n  cursor: not-allowed;\n\n  &:hover {\n    background-color: #f0f0f0;\n    color: #b3b3b3;\n  }\n}\n\n.voucher_list {\n  ul {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    list-style-type: none;\n    padding: 0;\n\n    li {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n\n      button {\n        border-radius: 5px;\n        border: 1px solid var(--green-light);\n        background-color: var(--green-light);\n        padding: 2px 4px;\n        cursor: pointer;\n        transition: all 0.3s;\n        font-size: 14px;\n\n        &:hover {\n          background-color: var(--primary-color);\n          color: white;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"voucher_payment_wrapper": `voucherPayment_voucher_payment_wrapper__Nduz5`,
	"search_wrapper": `voucherPayment_search_wrapper__DxCxH`,
	"voucher_payment_button": `voucherPayment_voucher_payment_button__8XP0l`,
	"payment_button": `voucherPayment_payment_button__BHzZ+`,
	"disabled": `voucherPayment_disabled__egMaA`,
	"voucher_list": `voucherPayment_voucher_list__kjEQk`
};
export default ___CSS_LOADER_EXPORT___;
